import { storeUser, storeUserError } from '../Redux/Actions/authActions';
import { userManager } from '../Config/userManager'

export async function loadUserFromStorage(store: any) {
  try {
    let user = await userManager.getUser()
    if (!user) {
      return store.dispatch(storeUserError())
    }
    store.dispatch(storeUser(user))
  } catch (e) {
    console.error(`User not found: ${e}`)
    store.dispatch(storeUserError())
  }
}

export function signinRedirect() {
  let response = userManager.signinRedirect()
  return response;
}

export function signinRedirectCallback() {
  return userManager.signinRedirectCallback()
}

export const signoutRedirect = async () => {
  const userIdToken = (await userManager.getUser())?.id_token
  userManager.clearStaleState()
  userManager.removeUser()
  localStorage.clear();
  return userManager.signoutRedirect({ id_token_hint: userIdToken })
}

export function signoutRedirectCallback() {
  userManager.clearStaleState()
  userManager.removeUser()
  return userManager.signoutRedirectCallback()
}

export const signinSilent = async () => {
  await userManager.signinSilent();
}

export const signinSilentCallback = async () => {
  await userManager.signinSilentCallback();
}

export default userManager